module.exports = __webpack_public_path__ + "05_mole.bae31131.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer2/05_mole.png
// module id = KQEm
// module chunks = 0